// extracted by mini-css-extract-plugin
export var container = "_9c-0";
export var containerTopRight = "_9c-1";